module.exports = __webpack_public_path__ + "static/4-5bf98dc4aa8d82601f6cbc16f8d3b053.jpeg";